/* Rosegold Sky wishlist: hearts saved in this browser (localStorage key "rgs-wishlist", a list of product handles). */
(function () {
  if (window.RGSWish) return;
  var KEY = 'rgs-wishlist';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function load() {
    try { var l = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(l) ? l : []; } catch (e) { return []; }
  }
  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    sync();
  }
  function sync() {
    var list = load();
    document.querySelectorAll('[data-rgs-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-rgs-wish')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var t = b.querySelector('[data-rgs-wish-label]');
      if (t) t.textContent = on ? 'Saved to wishlist' : 'Add to wishlist';
    });
    document.querySelectorAll('[data-rgs-wish-count]').forEach(function (c) {
      c.textContent = list.length;
      c.hidden = !list.length;
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rgs-wish]');
    if (!b) return;
    // The homepage product grid saves its own hearts; just refresh the counts after it.
    if (b.closest('.rgs-products')) { setTimeout(sync, 0); return; }
    e.preventDefault();
    var list = load(), h = b.getAttribute('data-rgs-wish'), at = list.indexOf(h);
    if (at > -1) list.splice(at, 1); else list.push(h);
    save(list);
  });
  window.addEventListener('storage', function (e) { if (e.key === KEY) { sync(); render(); } });

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function toast(html) {
    var t = document.getElementById('rgs-toast');
    if (!t) return;
    t.innerHTML = html; t.classList.add('is-visible');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-visible'); }, 3500);
  }

  function render() {
    var box = document.querySelector('[data-rgs-wishlist]');
    if (!box) return;
    var grid = box.querySelector('[data-wish-grid]');
    var list = load();
    var fmt;
    try { fmt = new Intl.NumberFormat(box.getAttribute('data-locale') || undefined, { style: 'currency', currency: box.getAttribute('data-currency') || 'USD' }); } catch (e) { fmt = { format: function (n) { return '$' + n.toFixed(2); } }; }

    function done(products) {
      products = products.filter(Boolean);
      var n = products.length;
      box.querySelector('[data-wish-count-text]').textContent = n ? n + (n > 1 ? ' saved pieces' : ' saved piece') : '';
      box.querySelector('[data-wish-empty]').hidden = n > 0;
      box.querySelector('[data-wish-foot]').hidden = n === 0;
      grid.hidden = n === 0;
      grid.innerHTML = products.map(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0] || {};
        var single = (p.variants || []).length <= 1;
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=500' : '';
        var btn = !p.available
          ? '<button class="rgs-btn" disabled>Sold out</button>'
          : single
            ? '<button class="rgs-btn" data-wish-add="' + v.id + '">Add to Cart</button>'
            : '<a class="rgs-btn" href="' + esc(p.url) + '">Choose Options</a>';
        return '<div class="rgs-acct__wish">' +
          '<div class="rgs-acct__wish-img"><a href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          '<button type="button" class="rgs-acct__wish-remove" data-wish-remove="' + esc(p.handle) + '" aria-label="Remove ' + esc(p.title) + ' from wishlist"><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 20s-7.5-4.6-9.2-9.3C1.7 7.4 3.8 4 7.2 4c2 0 3.6 1.1 4.8 2.8C13.2 5.1 14.8 4 16.8 4c3.4 0 5.5 3.4 4.4 6.7C19.5 15.4 12 20 12 20z"/></svg></button></div>' +
          '<div class="rgs-acct__wish-body"><a href="' + esc(p.url) + '"><strong>' + esc(p.title) + '</strong></a>' +
          '<span class="rgs-acct__wish-price">' + fmt.format((v.price != null ? v.price : p.price) / 100) + '</span>' +
          '<span class="rgs-acct__stock' + (p.available ? '' : ' is-out') + '">' + (p.available ? 'In stock' : 'Sold out') + '</span>' + btn + '</div></div>';
      }).join('');
    }

    if (!list.length) { done([]); return; }
    Promise.all(list.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (r.status === 404) { save(load().filter(function (x) { return x !== h; })); return null; }
          return r.ok ? r.json() : null;
        })
        .catch(function () { return null; });
    })).then(done);
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-wish-remove]');
    if (rm) {
      save(load().filter(function (x) { return x !== rm.getAttribute('data-wish-remove'); }));
      render();
      return;
    }
    var add = e.target.closest('[data-wish-add]');
    if (!add) return;
    add.disabled = true; add.textContent = 'Adding...';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +add.getAttribute('data-wish-add'), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return fetch(root + 'cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('rgs:cart-updated', { detail: cart }));
        add.textContent = 'Added ✓';
        toast('Added to your cart <a href="' + root + 'cart">View cart</a>');
      })
      .catch(function () { add.disabled = false; add.textContent = 'Try again'; });
  });

  window.RGSWish = { load: load, save: save, sync: sync, render: render };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { sync(); render(); });
  else { sync(); render(); }
})();
